module.exports = __webpack_public_path__ + "media/images/balik-32f9438aa09125d5d9429aeda752a7fa.jpg";